(function () {
  function initCuratedWatchesSlider(container) {
    if (!container) return;

    const grid = container.querySelector('.curated-watches-grid');
    if (!grid) return;

    grid.classList.add('js-slider');

    // create controls above the gallery
    const controls = document.createElement('div');
    controls.className = 'curated-watches-controls';
    const prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'prev';
    prev.setAttribute('aria-label', 'Previous');
  prev.innerHTML = '<svg width="16" height="27" viewBox="0 0 16 27" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path d="M1.00028 12.9213L1.97929 13.9221L14.3442 1.82596L13.3652 0.825195L1.00028 12.9213Z" fill="#252525" stroke="black"/>\n  <path d="M1.00028 13.5785L1.97929 12.5778L14.3442 24.6739L13.3652 25.6747L1.00028 13.5785Z" fill="#252525" stroke="black"/>\n</svg>';
    const next = document.createElement('button');
    next.type = 'button';
    next.className = 'next';
    next.setAttribute('aria-label', 'Next');
  next.innerHTML = '<svg width="16" height="27" viewBox="0 0 16 27" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path d="M14.6892 12.9213L13.7102 13.9221L1.34521 1.82596L2.32422 0.825195L14.6892 12.9213Z" fill="#252525" stroke="black"/>\n  <path d="M14.6892 13.5785L13.7102 12.5778L1.34521 24.6739L2.32422 25.6747L14.6892 13.5785Z" fill="#252525" stroke="black"/>\n</svg>';
    controls.appendChild(prev);
    controls.appendChild(next);

    // insert controls before grid (use grid.parentNode in case grid is nested inside another wrapper)
    if (grid.parentNode) {
      grid.parentNode.insertBefore(controls, grid);
    } else {
      container.insertBefore(controls, grid);
    }

    const items = Array.from(grid.children);
    if (!items.length) return;

    function itemWidth() {
      return items[0].getBoundingClientRect().width + parseFloat(getComputedStyle(grid).gap || 16);
    }

    function updateButtons() {
      prev.disabled = grid.scrollLeft <= 0;
      next.disabled = Math.ceil(grid.scrollLeft + grid.clientWidth) >= grid.scrollWidth - 1;
    }

    prev.addEventListener('click', function () {
      grid.scrollBy({ left: -itemWidth(), behavior: 'smooth' });
    });

    next.addEventListener('click', function () {
      grid.scrollBy({ left: itemWidth(), behavior: 'smooth' });
    });

    grid.addEventListener('scroll', throttle(updateButtons, 100));
    updateButtons();

    // drag to scroll
    let isDown = false;
    let isDragging = false;
    let startX, scrollLeft, pointerId;

    grid.addEventListener('pointerdown', (e) => {
      isDown = true;
      isDragging = false;
      pointerId = e.pointerId;
      startX = e.clientX;
      scrollLeft = grid.scrollLeft;
    });

    grid.addEventListener('pointermove', (e) => {
      if (!isDown) return;
      const walk = startX - e.clientX;
      // Only start dragging after a 5px threshold
      if (!isDragging && Math.abs(walk) > 5) {
        isDragging = true;
        grid.classList.add('is-dragging');
        try { grid.setPointerCapture(pointerId); } catch (err) {}
      }
      if (isDragging) {
        grid.scrollLeft = scrollLeft + walk;
      }
    });

    grid.addEventListener('pointerup', (e) => {
      isDown = false;
      if (isDragging) {
        try { grid.releasePointerCapture(e.pointerId); } catch (err) {}
        grid.classList.remove('is-dragging');
      }
    });

    grid.addEventListener('pointerleave', () => {
      isDown = false;
      isDragging = false;
      grid.classList.remove('is-dragging');
    });

    // Block click if we just finished dragging
    grid.addEventListener('click', (e) => {
      if (isDragging) {
        e.preventDefault();
        e.stopPropagation();
        isDragging = false;
      }
    }, true);

    // Prevent native drag on images/links (ghost image when dragging)
    grid.addEventListener('dragstart', (e) => e.preventDefault());

    // keyboard
    container.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') next.click();
      if (e.key === 'ArrowLeft') prev.click();
    });

    function throttle(fn, wait) {
      let time = Date.now();
      return function () {
        if ((time + wait - Date.now()) < 0) {
          fn.apply(this, arguments);
          time = Date.now();
        }
      };
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('#curated-watches-section').forEach((sec) => initCuratedWatchesSlider(sec));
  });
})();
